'use client';

import { getStockXUrl, isStockXAffiliateActive } from '@/lib/config/affiliate';
import { useTranslation } from '@/lib/i18n/LanguageContext';

interface AffiliateLinksProps {
  sneakerName: string;
  brand?: string;
  slug?: string;
}

export function AffiliateLinks({ sneakerName, brand, slug }: AffiliateLinksProps) {
  const { t } = useTranslation();

  const href = getStockXUrl({ slug, name: sneakerName, brand });
  const isAffiliate = isStockXAffiliateActive();

  return (
    <div className="border-t border-line pt-3">
      <p className="mb-2 text-center text-[10px] uppercase tracking-widest text-muted">
        {t('buyThisSneaker')}
      </p>
      <div className="flex justify-center">
        <a
          href={href}
          target="_blank"
          // "sponsored" only when the link really earns a commission
          rel={isAffiliate ? 'noopener noreferrer sponsored' : 'noopener noreferrer'}
          className="btn-ghost flex w-full max-w-xs items-center justify-center px-4 py-2 text-sm"
        >
          {t('viewOnStockX')}
        </a>
      </div>
      {isAffiliate && (
        <p className="mt-2 text-center text-[10px] text-muted/70">{t('affiliateDisclaimer')}</p>
      )}
    </div>
  );
}
